<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/setup/logRepulling")
          i.fa.fa-cog
          span.ml-1 {{ $t("ui.log_repulling") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.provider') }}
                    b-form-select(v-model="provider_code" :disabled="loading")
                      option(value='ONE') {{ $t('ui.one_api') }}
                div.row.col-md-8.mb-1
                  div(width="70%").mr-3
                    DateRangePicker(:value="dateRange" @update="getData")
                  div(width="30%")
                    SubmitButton(
                      :loading="loading"
                      icon="fa fa-paper-plane"
                      :text="$t('ui.submit')"
                      type="button"
                      @click="getRecord()"
                      variant="success"
                      size="sm"
                      ).mr-2
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateTimeRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker2.min.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    provider_code: "ONE",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD 00:00:00');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD 23:59:59');
  },
  methods: {
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'hours') > 24)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD HH:mm:ss');
    },
    getRecord: function() {
      if (this.checkDateRange()) {
        let url = "";
        var json = {
          startDate: this.$moment(this.dateRange.startDate).format('MM/DD/YYYY hh:mm:ss A'),
          endDate: this.$moment(this.dateRange.endDate).format('MM/DD/YYYY hh:mm:ss A')
        };

        if (this.provider_code == "ONE") url = config.logRepulling["oneUrl"];

        //console.log(json, url)

        if (url != "") {
          this.loading = true;
          this.$http.post(url, json).then(
            function(response) {
              this.loading = false;
              // Success
              try {
                if (response) {
                  if (typeof response.data.status == "string") {
                    this.feedback.success = response.data.status == "200";
                  } else {
                    this.feedback.success = response.data.status == 200;
                  }
                  this.feedback.status = response.data.statusdesc;
                  if (this.feedback.success == true) {
                    this.$helpers.showDialog(this.$t("ui.combine.log_repulling"), this.$t("message.success"), "success");
                  } else {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              } catch (error) {
                this.feedback.success = false;
                this.feedback.status = errorTags.request.failed;
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            },
            function(response) {
              this.loading = false;
              // Error
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          );
        } 
      } else {
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllow24Hours"), "error");
      }
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>